module.exports = __webpack_public_path__ + "img/组织机构维护.de4b840b.svg";